import { useEffect, useRef } from 'react';
import { KonkRideApp } from './proto/app';

let started = false;
/** React hosts the app; the prototype-identical views are painted by KonkRideApp (src/proto). */
export function ProtoApp() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (started || !ref.current) return;
    started = true;
    new KonkRideApp().mount(ref.current);
  }, []);
  return <div id="konkride-root" ref={ref} style={{ display: 'contents' }} />;
}
